module.exports = __webpack_public_path__ + "static/media/(DH)-Artesanato-19.0e01b425.jpg";